var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hotels",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M216,320h1.2v1.2H216Z",
    transform: "translate(-201 -309.2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M248,320h1.2v1.2H248Z",
    transform: "translate(-230.6 -309.2)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M280,320h1.2v1.2H280Z",
    transform: "translate(-260.2 -309.2)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M216,352h1.2v1.2H216Z",
    transform: "translate(-201 -338.8)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M248,352h1.2v1.2H248Z",
    transform: "translate(-230.6 -338.8)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M280,352h1.2v1.2H280Z",
    transform: "translate(-260.2 -338.8)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M216,384h1.2v1.2H216Z",
    transform: "translate(-201 -368.4)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M248,384h1.2v1.2H248Z",
    transform: "translate(-230.6 -368.4)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M280,384h1.2v1.2H280Z",
    transform: "translate(-260.2 -368.4)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M216,256h1.2v1.2H216Z",
    transform: "translate(-201 -250)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M248,256h1.2v1.2H248Z",
    transform: "translate(-230.6 -250)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M280,256h1.2v1.2H280Z",
    transform: "translate(-260.2 -250)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M216,288h1.2v1.2H216Z",
    transform: "translate(-201 -279.6)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M248,288h1.2v1.2H248Z",
    transform: "translate(-230.6 -279.6)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M280,288h1.2v1.2H280Z",
    transform: "translate(-260.2 -279.6)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M144,288h1.8v1.2H144Z",
    transform: "translate(-134.4 -279.6)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M144,328h1.8v1.2H144Z",
    transform: "translate(-134.4 -316.6)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M144,368h1.8v1.2H144Z",
    transform: "translate(-134.4 -353.6)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M144,408h1.8v1.2H144Z",
    transform: "translate(-134.4 -390.6)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M49.6,192.2H48.4a2.4,2.4,0,0,0-2.4,2.4v1.236a2.835,2.835,0,0,0-1.2.492V193.4H43.6v3H39.4V182.6h4.2v9.6h1.2V182a.6.6,0,0,0-.6-.6H39.4v-3a.6.6,0,0,0-.6-.6H37v-1.2a.6.6,0,0,0-.6-.6H31.6a.6.6,0,0,0-.6.6v1.2H29.2a.6.6,0,0,0-.6.6v3H23.8a.6.6,0,0,0-.6.6v3.6h1.2v-3h4.2v13.8H24.4v-9.6H23.2v9.527a2.835,2.835,0,0,0-1.2-.492V194.6a2.4,2.4,0,0,0-2.4-2.4H18.4a2.4,2.4,0,0,0-2.4,2.4v4.8a.6.6,0,0,0,.6.6H51.4a.6.6,0,0,0,.6-.6v-4.8A2.4,2.4,0,0,0,49.6,192.2Zm-17.4-15h3.6v2.4H32.2Zm-15,17.4a1.2,1.2,0,0,1,1.2-1.2h1.2a1.2,1.2,0,0,1,1.2,1.2v1.236a2.855,2.855,0,0,0-2.4,2.814v.15H17.2Zm2.4,4.2v-.15A1.652,1.652,0,0,1,21.25,197h.3a1.652,1.652,0,0,1,1.65,1.65v.15Zm4.8-1.2h4.2v1.2H24.4ZM29.8,179H31v1.2a.6.6,0,0,0,.6.6h4.8a.6.6,0,0,0,.6-.6V179h1.2v19.8H36.4v-4.2a.6.6,0,0,0-.6-.6H32.2a.6.6,0,0,0-.6.6v4.2H29.8Zm3,19.8v-3.6h2.4v3.6Zm6.6-1.2h4.2v1.2H39.4Zm5.4,1.2v-.15A1.652,1.652,0,0,1,46.45,197h.3a1.652,1.652,0,0,1,1.65,1.65v.15Zm6,0H49.6v-.15a2.855,2.855,0,0,0-2.4-2.814V194.6a1.2,1.2,0,0,1,1.2-1.2h1.2a1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(-16 -176)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M344,368h1.8v1.2H344Z",
    transform: "translate(-319.4 -353.6)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M344,408h1.8v1.2H344Z",
    transform: "translate(-319.4 -390.6)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M344,288h1.8v1.2H344Z",
    transform: "translate(-319.4 -279.6)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M344,328h1.8v1.2H344Z",
    transform: "translate(-319.4 -316.6)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsWhite);
export default __webpack_public_path__ + "static/media/HotelsWhite.69fb2051bc1dcfbf057e0839b00943da.svg";
export { ForwardRef as ReactComponent };